export default "__VITE_ASSET__RGamFNdi__"